import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SafeHtml } from "@angular/platform-browser";
import { TelenetIconComponent } from "../telenet-icons/telenet-icon.component";

@Component({
   selector: "my-cloud-custom-message",
   templateUrl: "./custom-message.component.html",
   styleUrls: ["./custom-message.component.scss"],
   imports: [TelenetIconComponent]
})
export class CustomMessageComponent {
   public isVisible: boolean = true;

   @Input() public canHide: boolean = false;

   @Input() public title?: string;
   @Input() public message: string | SafeHtml = "";
   @Input() public type: "info" | "error" | "warning" | "success" = "info";
   @Input() public hideIcon?: string | "close" = "close";

   @Output() public onHide: EventEmitter<void> = new EventEmitter<void>();

   public get isInfoMessage(): boolean {
      return this.type === "info";
   }

   public get isErrorMessage(): boolean {
      return this.type === "error";
   }

   public get isWarningMessage(): boolean {
      return this.type === "warning";
   }

   public get isSuccessMessage(): boolean {
      return this.type === "success";
   }

   public hide() {
      this.isVisible = false;
      this.onHide.emit();
   }
}
